import { Container, Row, Col, Card } from 'react-bootstrap';
import './Common.scss';

export default function Service() {
  // スクロール制御関数
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h1 className="display-4 mb-4 text-success">施術内容紹介</h1>
              <h2 className="h3 text-muted mb-4">
                ヒーリングサロンGundariの施術内容をご紹介します。
              </h2>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h2 id="portal" className="text-success">
                提供サービス
              </h2>
              <p className="lead">
                ヒーリングサロンGundariでは、以下の施術を提供しています。
                施術は全てMMS公認ヒーラーのドラゴニックシャーマンクンダリーニが行います。
                民間ですがカウンセラーの資格もありますので、ヒーリングに加えてお話を聞いてほしい場合も対応可能です。
              </p>
              <hr />
              <h2
                className="text-success"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('dna-activation')}
              >
                DNAアクティベーション
              </h2>
              <h2
                className="text-success"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('crystal-healing')}
              >
                クリスタルヒーリング
              </h2>
              <h2
                className="text-success"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('ensofic-reiki')}
              >
                エンソフィックレイキヒーリング
              </h2>
              <h2
                className="text-success"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('sacred-geometry')}
              >
                神性幾何学ヒーリング
              </h2>
              {/* <h2
                className="text-success"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('counseling')}
              >
                カウンセリング
              </h2> */}
            </Card.Body>
          </Card>
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} className="mt-4 d-flex">
          <Card className="shadow-sm slideinBottom">
            <Card.Body className="text-center py-5">
              <h1 id="dna-activation" className="text-success">
                DNAアクティベーション
              </h1>
              <Row>
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <img
                    src={require('../../images/DNA_activation.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <p className="lead">
                    DNAアクティベーションは、あなたのDNAを活性化し、潜在能力を引き出すための施術です。
                    科学的にはDNAって2重螺旋構造をしていて、私たちの遺伝情報を保持しているとされています。
                    でも、スピリチュアルの世界ではDNAって12重螺旋構造をしていて、私たちの魂の情報を保持しているとされています。
                    この施術では、24本のDNAのうちの22本を活性化し、あなたの魂が持つ使命へ向かっていく力を与えます。
                    この施術により、あなたのエネルギーが高まり、自己成長や変容を促進します。
                    DNAアクティベーションは、あなたの本来の力を引き出し、人生をより豊かにする手助けをします。
                  </p>
                </Col>
              </Row>
              <p className="lead mt-3 text-center">こんな方におすすめです。</p>
              <ul className="list-unstyled text-center">
                <li className="mb-2">自分の本当の姿を知りたい</li>
                <li className="mb-2">どうして生まれてきたのか知りたい</li>
                <li className="mb-2">人生をより豊かにしたい</li>
              </ul>
              <div className="text-center">
                <h2>施術時間: 60分</h2>
                <h2>料金: 15,000円</h2>
              </div>
              <p
                className="text-muted"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('portal')}
              >
                サービス一覧に戻る
              </p>
              <hr />
              <h1 id="crystal-healing" className="text-success">
                クリスタルヒーリング
              </h1>
              <Row>
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <img
                    src={require('../../images/crystal_healing.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <p className="lead">
                    全てのクリスタルがエネルギーを持っています。
                    そのエネルギーを使って、あなたの心と体を癒します。
                    クリスタルヒーリングは、あなたのエネルギーを調整し、バランスを取り戻すための施術です。
                    クリスタルのエネルギーは、あなたの体内のエネルギーを整え、心身の調和を促進します。
                    クリスタルヒーリングは、ストレスや不安を軽減し、リラックスした状態をもたらします。
                  </p>
                </Col>
              </Row>
              <p className="lead mt-3 text-center">こんな方におすすめです。</p>
              <ul className="list-unstyled text-center">
                <li className="mb-2">ストレスや不安を軽減したい</li>
                <li className="mb-2">心身のバランスを整えたい</li>
                <li className="mb-2">リラックスしたい</li>
                <li className="mb-2">クリスタルが好き</li>
              </ul>
              <h2>
                施術時間:
                15分(セッション1回あたり、体＋マインドなど複数セッションを受けたい場合は15×セッション数です)
              </h2>
              <h2>
                料金:
                1,500円(1セッションあたり、体＋マインドなど複数セッションを希望の場合は1,500×セッション数です)
              </h2>
              <p
                className="text-muted"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('portal')}
              >
                サービス一覧に戻る
              </p>
              <hr />
              <h1 id="ensofic-reiki" className="text-success">
                エンソフィックレイキヒーリング
              </h1>
              <Row>
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <img
                    src={require('../../images/reiki_healing.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <p className="lead">
                    エンソフィックレイキは、レイキヒーリングの祖臼井甕男によって開発されたヒーリング手法です。
                    このヒーリングは、あなたの肉体を浄化し、バランスを整えることで、深いリラクゼーションと治癒を促進します。
                    また、治したい悪癖や習慣がある場合は、その癖を手放すためのサポートも行います。
                    レイキを流している間、温泉に使っているような体がポカポカとする心地よさがあります。
                  </p>
                </Col>
              </Row>
              <p className="lead mt-3 text-center">こんな方におすすめです。</p>
              <ul className="list-unstyled text-center">
                <li className="mb-2">身体の不調を改善したい</li>
                <li className="mb-2">感情的なバランスを取りたい</li>
                <li className="mb-2">深いリラクゼーションを体験したい</li>
                <li className="mb-2">治したい悪癖や習慣がある</li>
              </ul>
              <h2>施術時間: 60分</h2>
              <h2>料金: 7,000円(対面、遠隔いずれも)</h2>
              <p
                className="text-muted"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('portal')}
              >
                サービス一覧に戻る
              </p>
              <hr />
              <h1 id="sacred-geometry" className="text-success">
                神性幾何学ヒーリング
              </h1>
              <Row>
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <img
                    src={require('../../images/sacred_geometry.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <p className="lead">
                    神性幾何学ヒーリングは、宇宙に存在する神聖な幾何学的パターンのエネルギーを使用したヒーリング手法です。
                    肉体やエーテル体にさまざまな幾何学模様を描くことで、あなたのエネルギーフィールドを調整し、高次の意識状態へと導きます。
                  </p>
                </Col>
              </Row>
              <p className="lead mt-3 text-center">こんな方におすすめです。</p>
              <ul className="list-unstyled text-center">
                <li className="mb-2">スピリチュアルな成長を求めている</li>
                <li className="mb-2">高次の意識状態を体験したい</li>
                <li className="mb-2">宇宙のエネルギーと繋がりたい</li>
                <li className="mb-2">神聖幾何学に興味がある</li>
              </ul>
              <h2>施術時間: 60分</h2>
              <h2>料金: 17,000円</h2>
              <p
                className="text-muted"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('portal')}
              >
                サービス一覧に戻る
              </p>
              {/* <hr />
              <h1 id="counseling" className="text-success">
                カウンセリング
              </h1>
              <Row>
                <Col
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <img
                    src={require('../../images/aria_icon.jpeg')}
                    alt="画像は開発中のものです"
                    className="img-fluid"
                  />
                </Col>
                <Col
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  className="mt-4 d-flex align-items-center"
                >
                  <p className="lead">
                    カウンセリングは、あなたの心の声に耳を傾け、内面の気づきを促すためのサポートを提供します。
                    どんな小さな悩みでもお気軽にご相談ください。あなたの心の健康を大切にするお手伝いをします。
                  </p>
                </Col>
              </Row>
              <p className="lead mt-3 text-center">こんな方におすすめです。</p>
              <ul className="list-unstyled text-center">
                <li className="mb-2">心のモヤモヤを解消したい</li>
                <li className="mb-2">自分自身を見つめ直したい</li>
                <li className="mb-2">ストレスを軽減したい</li>
                <li className="mb-2">人間関係を改善したい</li>
              </ul>
              <h2>施術時間: 60分</h2>
              <h2>料金: 6,000円</h2>
              <p
                className="text-muted"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => scrollToSection('portal')}
              >
                サービス一覧に戻る
              </p> */}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
